import { render, staticRenderFns } from "./AnalyticsAcademicStateColumnChart.vue?vue&type=template&id=029b6041&"
import script from "./AnalyticsAcademicStateColumnChart.vue?vue&type=script&lang=js&"
export * from "./AnalyticsAcademicStateColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports